import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const companyManagerEntityAdapter: EntityAdapter = {
  entity: "companyManager",
  isRowActionAllowed: (manager) => manager.is_ancestor_manager !== true,
  deleteQuestionKey: "delete_company_manager_question",
};
